/* eslint-disable react/jsx-pascal-case */
import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge, Checkbox, Button } from './ot'
import BaseListView1_1 from './base_list_view_1_1'
import BaseListView1_2 from './base_list_view_1_2'
import BaseListView1_3 from './base_list_view_1_3'
import BaseListView1_4 from './base_list_view_1_4'
import BaseListView1_5 from './base_list_view_1_5'
import BaseListView1_6 from './base_list_view_1_6'
import BaseListView1_7 from './base_list_view_1_7'
import {
    LayoutGrid,
    List,
    Eye,
    Edit,
    Share,
    Download,
    Search,
    Filter,
    Clock,
    MousePointer,
    FileText,
    TrendingUp,
} from "lucide-react"
import clsx from "clsx";
const BaseListView1 = ({
    showComponent = [
        "BaseListView1_1",
        "BaseListView1_2",
        "BaseListView1_3",
        "BaseListView1_4",
        "BaseListView1_5",
        "BaseListView1_6",
        "BaseListView1_7",
    ],
    baseListView1_1Props = {
        checked: false,
        onCheckedChange: () => { }
    },
    baseListView1_2Props = {
        value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
    },
    baseListView1_3Props = {
        value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
    },
    baseListView1_4Props = {
        stats: [
            {
                value: 1250,
                label: "瀏覽次數",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
                icon: <Eye className="h-4 w-4 text-blue-500" />
            },
            {
                value: 45,
                label: "撰寫文案",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
                icon: <FileText className="h-4 w-4 text-green-500" />


            },
            {
                value: 320,
                label: "點擊次數",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
                icon: <MousePointer className="h-4 w-4 text-purple-500" />

            },
            {
                value: 28,
                label: "複製次數",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
                icon: <TrendingUp className="h-4 w-4 text-orange-500" />

            },
        ]
    },
    baseListView1_5Props = {
        badges: [
            {
                label: "王小明",
                variant: "outline",
                className: ""
            },
            {
                label: <><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <path d="M8 11h8" />
                    <path d="M8 15h8" />
                    <path d="M8 7h8" />
                </svg>2025-05-30</>,
                variant: "outline",
                className: ""
            },
        ]
    },
    baseListView1_6Props = {
        children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
    },
    baseListView1_7Props = {
        buttons: [
            <Button variant="outline" className="flex-1">
                <Eye className="h-4 w-4 mr-1" />
                查看
            </Button>,
            <Button className="flex-1">
                <Edit className="h-4 w-4 mr-1" />
                複製文案內容並編輯
            </Button>,
            <Button variant="ghost" size="sm">
                <Share className="h-4 w-4 mr-1" />
                分享
            </Button>,
            <Button variant="ghost" size="sm">
                <Download className="h-4 w-4 mr-1" />
                匯出
            </Button>,
            <Button variant="ghost" size="sm" className="text-red-600">
                刪除
            </Button>,
        ],
        buttonGroupsColumnsCount: [2, 3],
    },
    baseListView1Props = {
        inline1_7: true
    }

}, ref) => {

    return (
        <>
            <div className="flex items-start border rounded-md p-2 sm:p-3 bg-white hover:bg-gray-50 gap-1.5 sm:gap-2">
                <div className="flex items-center flex-shrink-0">
                    {showComponent.includes("BaseListView1_1") && (
                        <BaseListView1_1 {...baseListView1_1Props} />
                    )}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start gap-1.5">
                        <div className="flex items-center gap-2 min-w-0">
                            {showComponent.includes("BaseListView1_2") && (
                                <BaseListView1_2 {...baseListView1_2Props} />
                            )}
                        </div>
                    </div>
                    {showComponent.includes("BaseListView1_3") && (
                        <div className="mt-0.5">
                            <BaseListView1_3 {...baseListView1_3Props} />
                        </div>
                    )}

                    {/* 統計數據區域 - 列表模式 */}
                    {showComponent.includes("BaseListView1_4") && baseListView1_4Props?.stats.length > 0 && (<div className="flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4 mt-1 sm:mt-2 p-1 sm:p-1.5 bg-gray-50 rounded-md">
                        <BaseListView1_4 {...baseListView1_4Props} />
                    </div>)}

                    {showComponent.includes("BaseListView1_5") && (
                        <BaseListView1_5 {...baseListView1_5Props} />
                    )}
                    {showComponent.includes("BaseListView1_6") && (
                        <BaseListView1_6 {...baseListView1_6Props}  >
                            {baseListView1_6Props?.children}
                        </BaseListView1_6>
                    )}
                    {!baseListView1Props?.inline1_7 &&
                        <div className="flex items-center gap-1.5 flex-wrap">
                            {showComponent.includes("BaseListView1_7") && (
                                <BaseListView1_7 {...baseListView1_7Props} />
                            )}
                        </div>}
                </div>
                {baseListView1Props?.inline1_7 &&
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        {showComponent.includes("BaseListView1_7") && (
                            <BaseListView1_7 {...baseListView1_7Props} />
                        )}
                    </div>}
            </div>


            {false && <section
                className={[
                    "group",
                    "flex flex-col md:grid",
                    // 改：左側固定，中間 3fr，右側 1fr
                    "md:[grid-template-columns:auto_minmax(0,3fr)_minmax(0,1fr)]",
                    "border rounded-2xl",
                    "p-3 sm:p-4 md:p-4 lg:p-5",
                    "bg-white",
                    "md:hover:bg-gray-50",
                    "md:items-start md:gap-4",
                    "shadow-sm md:shadow",
                ].join(" ")}
                aria-label="base list view card"
            >
                {/* Left Aside */}
                <aside
                    className={[
                        "flex items-center",
                        "mb-2 md:mb-0",
                        "shrink-0",
                        "md:max-w-[3rem] md:w-[3rem] lg:max-w-[3.5rem] lg:w-[3.5rem]",
                    ].join(" ")}
                >
                    {showComponent.includes("BaseListView1_1") && (
                        <BaseListView1_1 {...baseListView1_1Props} />
                    )}
                </aside>

                {/* Main Content */}
                <div className="min-w-0">
                    {/* Header */}
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1.5">
                        <div className="flex items-center flex-wrap gap-1.5 min-w-0">
                            {showComponent.includes("BaseListView1_2") && (
                                <BaseListView1_2 {...baseListView1_2Props} />
                            )}
                        </div>
                    </div>

                    {/* Description */}
                    {showComponent.includes("BaseListView1_3") && (
                        <div className="mt-1.5 sm:mt-2">
                            <BaseListView1_3 {...baseListView1_3Props} />
                        </div>
                    )}

                    {/* Stats Area */}
                    <div
                        className={[
                            "mt-2",
                            "bg-gray-50",
                            "rounded-lg", // 稍微縮小圓角
                            "p-1.5 sm:p-2 md:p-2.5",
                        ].join(" ")}
                    >
                        {showComponent.includes("BaseListView1_4") && (
                            <div
                                className={clsx(
                                    "grid",
                                    "[grid-template-columns:repeat(auto-fit,minmax(13rem,1fr))] lg:[grid-template-columns:repeat(auto-fit,minmax(15rem,1fr))]",
                                    "[&>*]:min-w-0",
                                    "gap-1.5 sm:gap-2 lg:gap-3",
                                    "items-start"
                                )}
                            >
                                <BaseListView1_4 {...baseListView1_4Props} />
                            </div>
                        )}
                    </div>
                    {/* Body + Footer Actions 並排 */}
                    {(showComponent.includes("BaseListView1_5") ||
                        showComponent.includes("BaseListView1_6")) && (
                            <div
                                className={[
                                    "mt-2",
                                    "flex flex-col sm:flex-row", // 手機直排、平板以上並排
                                    "gap-2 sm:gap-3",           // 區塊之間間距
                                    "items-start sm:items-center", // 對齊方式
                                ].join(" ")}
                            >
                                {showComponent.includes("BaseListView1_6") && (
                                    <div className="shrink-0">
                                        <BaseListView1_6 {...baseListView1_6Props}>
                                            {baseListView1_6Props?.children}
                                        </BaseListView1_6>
                                    </div>
                                )}
                                {showComponent.includes("BaseListView1_5") && (
                                    <div className="flex-1 min-w-0">
                                        <BaseListView1_5 {...baseListView1_5Props} />
                                    </div>
                                )}
                            </div>
                        )}
                </div>

                {/* Right Aside */}
                <aside
                    className={[
                        "flex items-center gap-1.5",
                        "mt-2 md:mt-0",
                        "shrink-0 grow-0",
                        // 拿掉硬固定 px，讓 grid fr 控制比例
                        "lg:sticky lg:top-4",
                        "md:flex-col md:items-end md:text-sm",
                        "min-w-0", // 避免文字超出
                    ].join(" ")}
                >
                    {showComponent.includes("BaseListView1_7") && (
                        <BaseListView1_7 {...baseListView1_7Props} />
                    )}
                </aside>
            </section>}
        </>
    )
}

export default BaseListView1
